import React from 'react';

import { Box, Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import {
  struckThroughValueStyles,
  calculatedStyles,
  revertButtonStyles,
  wrapperStyles,
} from './CalculatedValueHelper.styles';

/**
 * Inline "system-calculated value beside a field" affordance: shows the
 * calculated value, an optional signed difference from the current value, and
 * a Revert action. Used as a field's `customHelper` (see `TextFieldCDS`).
 */
const CalculatedValueHelper = ({
  calculatedValue,
  differenceLabel,
  isRevertHidden,
  isValueStruckThrough,
  label = 'Calculated',
  onRevert,
  revertButtonTestId,
}) => (
  <Box sx={wrapperStyles}>
    <Box sx={calculatedStyles}>
      <Typography color="text.secondary" variant="regular12">
        {label}
      </Typography>
      <Typography
        color="text.secondary"
        sx={isValueStruckThrough ? struckThroughValueStyles : null}
        variant="regular12"
      >
        {calculatedValue}
      </Typography>
    </Box>

    {!!differenceLabel && (
      <Typography color="text.tableHighlight" variant="regular12">
        {differenceLabel}
      </Typography>
    )}

    {!isRevertHidden && (
      <Button
        data-testid={revertButtonTestId}
        size="small"
        sx={revertButtonStyles}
        variant="text"
        onClick={onRevert}
      >
        Revert
      </Button>
    )}
  </Box>
);

CalculatedValueHelper.propTypes = {
  calculatedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onRevert: PropTypes.func.isRequired,
  differenceLabel: PropTypes.string,
  isRevertHidden: PropTypes.bool,
  isValueStruckThrough: PropTypes.bool,
  label: PropTypes.string,
  revertButtonTestId: PropTypes.string,
};

export default CalculatedValueHelper;
